import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../api/client/client.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import Sortable from 'sortablejs'
import { TraineeService } from 'api/trainee/trainee.service';
import { Title } from '@angular/platform-browser';
// import {ToasterService} from '../../toaster-service.service';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'trainee-page',
    templateUrl: './trainee.html'
})

export class Trainee implements OnInit {

    allproject = [];
    description: any;
    id : String;
    i : number;

    constructor(private newProjectservice: TraineeService,
        private router: Router ,private titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("New Project  | Phoenix Games");
        this.newProjectservice.allnewproject().then(data => {
            this.allproject = data;
        })

    }

    downloadfile(name) {
        this.newProjectservice.downloadFile(name);
    }
    openView(id) {
        // for (let i = 0; i < this.allproject.length; i++) {
        //     if (id == this.allproject[i].id) {
        //         this.description = this.allproject[i].description
        //     }
        // }
    }
    cancelAction(){
        this.id = "";
    }
    deleteconfirmation(id,i){
        this.id = id;
        this.i = i;
    }

    deleteproject(){
        this.newProjectservice.dHiring(this.id).then(data => {
            if (data.status) {
                this.allproject.splice(this.i, 1);
                $.notify({
                    message: "Successfully Deleted"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                this.cancelAction();
            }
        });

    }


}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/trainee/trainee.page.ts